import type { JunipProduct } from 'types/reviews/JunipProduct';

export const getJunipProductsBySlugs = (
  products: JunipProduct[] | undefined,
  slugs: string[],
): JunipProduct[] =>
  products?.filter(
    (product) =>
      product.remoteHandle != null && slugs.includes(product.remoteHandle),
  ) ?? [];
